<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" @click="getAddBonusPayment()" v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('setting_bonuspayment.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditBonusPayment()" v-if="permissionList.includes(permission.edit)">{{$t('setting_bonuspayment.table_edit')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteBonusPayment()" v-if="permissionList.includes(permission.delete)">{{$t('setting_bonuspayment.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addBonusPayment" :title="$t('setting_bonuspayment.table_add')" size="lg" @ok="addBonusPayment" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addBonusPaymentForm" @submit.prevent="addBonusPayment">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_bonuspayment.table_account_type')}}</template>
                            <b-input-group>
                                <b-form-select v-model="ajaxAdd.account_type" id="account_type1">
                                    <option v-for="(accountList,index) in ajaxAddList.account_list" :key="index" :value="accountList.id">{{accountList.name}}</option>
                                </b-form-select>
                                <b-input-group-append>
                                    <b-button variant="primary" @click="addAccountType()"><font-awesome-icon icon="plus"/></b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <p class="bonus-show" v-for="(type,index) in ajaxShow.account_type" :key="index" @click="removeAccountType(index)">
                                <font-awesome-icon icon="times"/> {{type.name}} 
                                <input type="hidden" :value="type.id" :name="'at_id[' + type.id + ']'"/>
                            </p>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_bonuspayment.table_bonus_type')}}</template>
                            <b-form-select v-model="ajaxAdd.bonus_type" name="attribute_id">
                                <option v-for="(bonusList,index) in ajaxAddList.bonus_list" :key="index" :value="bonusList.id">{{bonusList.code}} ({{bonusList.name}})</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_bonuspayment.table_package')}}</template>
                            <b-input-group>
                                <b-form-select v-model="ajaxAdd.package" id="package1">
                                    <option v-for="(packageList,index) in ajaxAddList.package_list" :key="index" :value="packageList.id">{{packageList.code}} - {{packageList.name}}</option>                                   
                                </b-form-select>
                                <b-input-group-append>
                                    <b-button variant="primary" @click="addPackage()"><font-awesome-icon icon="plus"/></b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <p class="bonus-show" v-for="(type,index) in ajaxShow.package" :key="index" @click="removePackage(index)">
                                <font-awesome-icon icon="times"/> {{type.name}}
                                <input type="hidden" :value="type.id" :name="'package_id[' + type.id + ']'"/>
                            </p>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4" class="mb-0">
                            <template slot="label">{{$t('setting_bonuspayment.table_radio')}}</template>
                        </b-form-group>
                        <div class="custom-from-group">
                            <b-form-group label-cols="12" label-cols-lg="4" v-for="(walletList,index) in ajaxAddList.wallet_list" :key="index" name="wallet[]">
                                <template slot="label">{{walletList.code}}</template>
                                <b-form-input :name="'formula[' + walletList.id + ']'" value="0"></b-form-input>
                            </b-form-group>
                        </div>
                    </form>
                </b-modal>
                <b-modal id="editBonusPayment" :title="$t('setting_bonuspayment.table_edit')" size="lg" @ok="editBonusPayment" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editBonusPaymentForm" @submit.prevent="editBonusPayment">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_bonuspayment.table_account_type')}}</template>
                            <b-form-select v-model="ajaxEdit.at_id" name="at_id">
                                <option v-for="(accountList,index) in ajaxEditList.account_list" :key="index" :value="accountList.id" :code="accountList.name">{{accountList.name}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_bonuspayment.table_bonus_type')}}</template>
                            <b-form-select v-model="ajaxEdit.attribute_id" name="attribute_id">
                                <option v-for="(bonusList,index) in ajaxEditList.bonus_list" :key="index" :value="bonusList.id">{{bonusList.code}} ({{bonusList.name}})</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_bonuspayment.table_package')}}</template>
                            <b-form-select v-model="ajaxEdit.package_id" name="package_id">
                                <option v-for="(packageList,index) in ajaxEditList.package_list" :key="index" :value="packageList.id">{{packageList.code}} - {{packageList.name}}</option>                                   
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4" class="mb-0">
                            <template slot="label">{{$t('setting_bonuspayment.table_radio')}}</template>
                        </b-form-group>
                        <div class="custom-from-group">
                            <b-form-group label-cols="12" label-cols-lg="4" v-for="(walletList,index) in ajaxEditList.wallet_list" :key="index" name="wallet[]">
                                <template slot="label">{{walletList.code}}</template>
                                <b-form-input :name="'formula[' + walletList.id + ']'" :value="walletList.value"></b-form-input>
                            </b-form-group>
                        </div>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,setting_bonuspaymentAjaxTable,getSetting_BonusPaymentAdd,setting_bonuspaymentAdd,getSetting_BonusPaymentEdit,setting_bonuspaymentEdit,setting_bonuspaymentDelete,setting_bonuspaymentCheckPackage} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',at_id:'',attribute_id:'',package_id:'',formula:''},
            ajaxAdd:{account_type:'',bonus_type:'',package:'',wallet:''},
            ajaxAddList:{account_list:[],bonus_list:[],package_list:[],wallet_list:[]},
            ajaxEdit:[],
            ajaxEditList:{account_list:[],bonus_list:[],package_list:[],wallet_list:[]},
            ajaxShow:{account_type:[],package:[]},
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'9E7392',
                edit:'2777CC',
                delete:'B8A38C'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('setting_bonuspayment.table_id'),
                width: '147'
            },{
                prop: "at_id",
                label: this.$t('setting_bonuspayment.table_account_type'),
                width: '217'
            },{
                prop: "attribute_id",
                label: this.$t('setting_bonuspayment.table_bonus_type'),
                width: '217'
            },{
                prop: "package_id",
                label: this.$t('setting_bonuspayment.table_package'),
                width: '217'
            },{
                prop: "formula",
                label: this.$t('setting_bonuspayment.table_formula'),
                width: '724'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = setting_bonuspaymentAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.at_id,this.ajaxSearch.attribute_id,this.ajaxSearch.package_id);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },addAccountType(){
            var type = document.getElementById("account_type1");
            var data = this.ajaxShow.account_type;
            var valid = true;
            for(var i=0;i<data.length;i++){
                if(data[i].id == this.ajaxAdd.account_type){
                    valid = false;
                }
            }
            if(valid){
                this.ajaxShow.account_type.push({'id':this.ajaxAdd.account_type,'name':type.options[type.selectedIndex].text});
            }       
        },removeAccountType(index){
            this.ajaxShow.account_type.splice(index,1)
        },addPackage(){
            var package1 = document.getElementById("package1");
            var data = this.ajaxShow.package;
            var valid = true;
            for(var i=0;i<data.length;i++){
                if(data[i].id == this.ajaxAdd.package){
                    valid = false;
                }
            }
            if(valid){
                this.ajaxShow.package.push({'id':this.ajaxAdd.package,'name':package1.options[package1.selectedIndex].text});
            }  
        },removePackage(index){
            this.ajaxShow.package.splice(index,1)
        },getAddBonusPayment(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var result = getSetting_BonusPaymentAdd();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('addBonusPayment')
                        self.ajaxAddList.account_list = value.data.account_list;
                        self.ajaxAddList.bonus_list = value.data.attribute_list;
                        self.ajaxAddList.package_list = value.data.pacakge_list;
                        self.ajaxAddList.wallet_list = value.data.wallet_list;
                        self.ajaxAdd.account_type = self.ajaxAddList.account_list[0].id;
                        self.ajaxAdd.bonus_type = self.ajaxAddList.bonus_list[0].id;
                        self.ajaxAdd.package = self.ajaxAddList.package_list[0].id;
                    }
                });
            }
        },addBonusPayment(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(this.validate){
                    var form = document.getElementById('addBonusPaymentForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue);  
                    var result = setting_bonuspaymentAdd(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    });    
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                    
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                }  
            }       
        },getEditBonusPayment(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getSetting_BonusPaymentEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editBonusPayment');
                        self.ajaxEdit = value.data.this_detail;
                        self.ajaxEditList.account_list = value.data.account_list;
                        self.ajaxEditList.bonus_list = value.data.attribute_list;
                        self.ajaxEditList.package_list = value.data.pacakge_list;
                        self.ajaxEditList.wallet_list = value.data.wallet_list;
                    }else{
                        var text = "";
                        self.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        self.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editBonusPayment(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                if(this.validate){
                    var form = document.getElementById('editBonusPaymentForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    var result = setting_bonuspaymentEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                } 
            }
        },deleteBonusPayment(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = setting_bonuspaymentDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
